document.querySelectorAll('.countdown-timer').forEach(e => {
    // Parse the date string from the data-time attribute
    const countDownDate = new Date(e.dataset.time).getTime();

    const interval = setInterval(function () {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        if (distance < 0) {
            clearInterval(interval);
            e.innerHTML = "EXPIRED";
            return;
        }

        // Calculate time parts
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Update DOM elements scoped to this timer
        e.querySelector('.days').textContent = days;
        e.querySelector('.hours').textContent = hours;
        e.querySelector('.minutes').textContent = minutes;
        e.querySelector('.seconds').textContent = seconds;
    }, 1000);
});
